// Conserve l'iframe et les éléments inchangés, notamment les images déjà chargées.
export function updateAccreditationPreview(frame, html, { preserveUserPhoto = false } = {}) {
  const currentDocument = frame.contentDocument
  if (!currentDocument?.querySelector("#generated_accred")) return false

  const nextDocument = new DOMParser().parseFromString(html, "text/html")
  if (!nextDocument.querySelector("#generated_accred")) return false

  const selectors = [
    ".texts .name", ".texts_add", "#qrcode", "#serial",
    ".accreditation-days-content", ".accreditation-zones-content", ".accreditation-custom-bottom-text"
  ]
  const replacements = selectors.map(selector => [currentDocument.querySelector(selector), nextDocument.querySelector(selector)])
  if (replacements.some(([currentElement, nextElement]) => !currentElement && nextElement)) return false

  replacements.forEach(([currentElement, nextElement]) => {
    if (!currentElement || !nextElement || currentElement.isEqualNode(nextElement)) return

    currentElement.replaceWith(currentDocument.importNode(nextElement, true))
  })

  for (const selector of [".top", ".bottom", "#verso_wrapper", ".specimen-watermark"]) {
    updateAttributes(currentDocument, nextDocument, selector, ["class", "style"])
  }

  updateElement(currentDocument, nextDocument, ".top > img", ".top")
  updateElement(currentDocument, nextDocument, "#verso_content > img", "#verso_content")
  updateElement(currentDocument, nextDocument, ".texts .profile", ".texts", ".name")
  updateElement(currentDocument, nextDocument, ".event-commander-corners", "#content")
  if (!preserveUserPhoto) updateElement(currentDocument, nextDocument, ".middle > .avatar", ".middle", ".texts")

  return true
}

function updateAttributes(currentDocument, nextDocument, selector, attributes) {
  const currentElement = currentDocument.querySelector(selector)
  const nextElement = nextDocument.querySelector(selector)
  if (!currentElement || !nextElement) return

  attributes.forEach(attribute => {
    if (nextElement.getAttribute(attribute) === currentElement.getAttribute(attribute)) return

    if (nextElement.hasAttribute(attribute)) {
      currentElement.setAttribute(attribute, nextElement.getAttribute(attribute))
    } else {
      currentElement.removeAttribute(attribute)
    }
  })
}

function updateElement(currentDocument, nextDocument, selector, parentSelector, beforeSelector = null) {
  const currentElement = currentDocument.querySelector(selector)
  const nextElement = nextDocument.querySelector(selector)
  if (currentElement && nextElement) {
    if (!currentElement.isEqualNode(nextElement)) currentElement.replaceWith(currentDocument.importNode(nextElement, true))
    return
  }
  if (currentElement && !nextElement) {
    currentElement.remove()
    return
  }
  if (!nextElement) return

  const parent = currentDocument.querySelector(parentSelector)
  if (!parent) return

  parent.insertBefore(currentDocument.importNode(nextElement, true), beforeSelector ? parent.querySelector(beforeSelector) : null)
}
